<template>
  <div class="about main-container light-bg">
    <v-layout align-center class="grid grid-one light-bg">
        <h3 class="display-3">Om oss</h3>
        <p class="sub-headline">Vi utvecklar användarvänliga databaslösningar med framförallt FileMaker som teknisk plattform.</p>
    </v-layout>
    <v-layout  v-if="wpData" align-center class="grid grid-one blue-bg" data-aos-duration="800" data-aos-easing="ease-in-out">
      <section class="grid-item" v-html="wpData"></section>
    </v-layout>
     <v-layout v-else class="grid grid-one blue-bg" data-aos="fade-in">
        <section class="grid-item" style="width:100%;">
          <v-skeleton-loader class="mx-auto bluebackground" type="article"></v-skeleton-loader>
        </section>
      </v-layout>
    
    
    <v-layout align-center class="grid grid-one light-bg pb-0">
        <h3 class="display-3">Vilka är vi?</h3>
    </v-layout>
    <div class="light-bg staff grid customer-case-grid one-third" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
      <div class="pb-5 px-4 ccase-grid-item grid-one" style="width:100%" v-for="(employee, index) in staff" :key="index">
        <v-card class="mx-auto " max-width="400">
          <!-- <img v-bind:src="employee.image" class="employee-img"> -->
          <v-card-title><h2>{{employee.name}}</h2></v-card-title>
          <v-card-text class="text--primary pt-0">
            <div>{{employee.title}}</div>
            <div v-html="employee.email"></div>
          </v-card-text>
        </v-card>
        <!-- <v-card class="mx-auto employee-card" max-width="500" max-height="140"  style="flex-direction:row;justify-content:space-between;">
          <div>
            <v-card-title><h2>{{employee.name}}</h2></v-card-title>
          <v-card-text class="text--primary pt-0">
            <div>{{employee.title}}</div>
            <div>{{employee.phone}}</div>
          </v-card-text>
          </div>
          <div><img v-bind:src="employee.image" class="employee-img"></div>
        </v-card> -->
      </div>
    </div>
    <v-layout align-center class="" style="position:relative;">
      <!-- <div class="our-position hide-on-small-screens "><p>Här nånstans sitter vi</p><v-icon>call_received</v-icon></div> -->
        <img src="../assets/imgs/hbg.jpg" class="">
    </v-layout>
  </div>

</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import robert from '../assets/imgs/staff/robert.jpg';
    import jesper from '../assets/imgs/staff/jesper.jpg';
    import billy from '../assets/imgs/staff/billy.jpg';
    import staffan from '../assets/imgs/staff/staffan.jpg';
    import mikael from '../assets/imgs/staff/mikael.jpg';

    @Component({
        data(){
            return {
              wpData: "",
              staff: [
                {
                  name: 'Robert Eriksson',
                  title: 'Affärsutvecklare',
                  phone: '0704 - 20 57 15',
                  email: 'robert.<!--abc@abc.com-->eriksson@<!--def@def.com-->smartasystem.se',
                  image: robert
                },
                {
                  name: 'Jesper Olsson',
                  title: 'Utvecklare',
                  phone: '0704 - 56 10 58',
                  email: 'jesper.<!--abc@abc.com-->olsson@<!--def@def.com-->smartasystem.se',
                  image: jesper
                },
                {
                  name: 'Staffan Johansson',
                  title: 'Ekonomiansvarig',
                  phone: '-',
                  email: 'staffan.<!--abc@abc.com-->johansson@<!--def@def.com-->smartasystem.se',
                  image: staffan
                },
                {
                  name: 'Billy Snöberg',
                  title: 'Utvecklare',
                  phone: '0704 - 20 57 27',
                  email: 'billy.<!--abc@abc.com-->snoberg@<!--def@def.com-->smartasystem.se',
                  image: billy
                },
                {
                  name: 'Mikael Elmgren',
                  title: 'Utvecklare',
                  phone: '0704 - 18 58 11',
                  email: 'mikael.<!--abc@abc.com-->elmgren@<!--def@def.com-->smartasystem.se',
                  image: mikael
                }
              ]
            }
        },
        components: {},
        methods: {
           async getOmoss(){
            await fetch(this.$store.state.URL+'pages/19')
            .then((r) => r.json())
            .then((res) => {
              // console.log(res);
              this.wpData = res.content.rendered
              });
            },
        },
        beforeMount(){
          this.getOmoss()
        }
    })
    export default class Om extends Vue {}
</script>
<style lang="scss">

 .our-position {
   position: absolute;
   right: 10%;
   top:10%;
   p {
     font-weight: 700;
   }
 }
</style>